import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight, Brain, GraduationCap, Sparkle } from "@phosphor-icons/react";

// Home "One ecosystem, three doorways" section — Couch / Forward / ATLAS.
// Extracted from Home.jsx so the parent stays focused on top-level composition.
export default function HomeEcosystemSection() {
  return (
    <section className="md-section md-home-ecosystem" data-testid="ecosystem-section">
      <div className="md-home-ecosystem-bg" aria-hidden />
      <div className="md-container">
        <div className="text-center max-w-3xl mx-auto mb-10">
          <div className="md-label-eyebrow mb-3" style={{ color: "var(--md-secondary)" }}>The three-arm ecosystem</div>
          <h2 className="text-4xl md:text-5xl font-serif mb-3">One ecosystem, <em style={{ color: "var(--md-secondary)", fontStyle: "italic" }}>three doorways</em></h2>
          <p className="text-lg md-home-ecosystem-sub">
            Care, growth and evidence, connected, but distinct. Pick the doorway closest to where you are.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {/* COUCH */}
          <div className="md-card flex flex-col items-start" data-testid="ecosystem-couch">
            <div className="ecosystem-ico ecosystem-ico-couch"><Brain size={28} weight="duotone" /></div>
            <div className="md-label-eyebrow mt-5" style={{ color: "var(--md-secondary-dark)" }}><span className="md-brand">MindDhara</span> · Couch</div>
            <h3 className="text-2xl font-serif mt-3" style={{ color: "var(--md-primary)" }}>Brain Health &amp; Mind Care</h3>
            <p className="text-sm mt-3 flex-1" style={{ color: "var(--md-text-soft)" }}>
              Helping you better understand your brain and mind, so everyday life feels a little less overwhelming and a little more manageable.
            </p>
            <ul className="mt-4 text-sm space-y-1.5" style={{ color: "var(--md-text-soft)" }}>
              <li>· Cognitive Support</li>
              <li>· Everyday wellbeing</li>
              <li>· Psychological Assessments</li>
              <li>· Structured pathways</li>
              <li>· Culturally-Informed Care</li>
            </ul>
            <Link to="/couch?source=home-ecosystem" className="btn-primary text-sm mt-6" data-testid="ecosystem-couch-cta">Start a Conversation <ArrowRight size={14} weight="bold" /></Link>
          </div>

          {/* FORWARD */}
          <div className="md-card flex flex-col items-start" data-testid="ecosystem-forward">
            <div className="ecosystem-ico ecosystem-ico-forward"><GraduationCap size={28} weight="duotone" /></div>
            <div className="md-label-eyebrow mt-5" style={{ color: "var(--md-secondary-dark)" }}><span className="md-brand">MindDhara</span> · Forward</div>
            <h3 className="text-2xl font-serif mt-3" style={{ color: "var(--md-primary)" }}>Mentorship &amp; Career Growth</h3>
            <p className="text-sm mt-3 flex-1" style={{ color: "var(--md-text-soft)" }}>
              Helping you navigate psychology careers with greater clarity, confidence, and perspective, from traditional routes to emerging opportunities worldwide.
            </p>
            <ul className="mt-4 text-sm space-y-1.5" style={{ color: "var(--md-text-soft)" }}>
              <li>· The First Mile</li>
              <li>· The Crossing</li>
              <li>· The Horizon</li>
              <li>· Couch (embedded wellbeing layer)</li>
            </ul>
            <Link to="/forward?source=home-ecosystem" className="btn-primary text-sm mt-6" data-testid="ecosystem-forward-cta">Explore Forward <ArrowRight size={14} weight="bold" /></Link>
          </div>

          {/* ATLAS, external */}
          <div className="md-card flex flex-col items-start" data-testid="ecosystem-atlas">
            <div className="ecosystem-ico ecosystem-ico-atlas"><Sparkle size={28} weight="duotone" /></div>
            <div className="md-label-eyebrow mt-5" style={{ color: "var(--md-secondary-dark)" }}><span className="md-brand">MindDhara</span> · ATLAS</div>
            <h3 className="text-2xl font-serif mt-3" style={{ color: "var(--md-primary)" }}>Research &amp; Evidence Base</h3>
            <p className="text-sm mt-3 flex-1" style={{ color: "var(--md-text-soft)" }}>
              A research publishing platform and knowledge base, featuring a student ambassador programme across UK universities. Lives on its own home: atlasdhara.com.
            </p>
            <ul className="mt-4 text-sm space-y-1.5" style={{ color: "var(--md-text-soft)" }}>
              <li>· Research publishing platform</li>
              <li>· Knowledge base</li>
              <li>· Student ambassador programme</li>
              <li>· UK university network</li>
            </ul>
            <a href="https://atlasdhara.com" target="_blank" rel="noreferrer" className="btn-primary text-sm mt-6" data-testid="ecosystem-atlas-cta">
              Visit atlasdhara.com <ArrowUpRight size={14} weight="bold" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
